var $da9b443e89eebc6b$exports = {};
$da9b443e89eebc6b$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Sz\xednv\xe1laszt\xf3`,
    "colorSwatch": `sz\xednt\xe1r`,
    "transparent": `\xe1tl\xe1tsz\xf3`,
    "twoDimensionalSlider": `2D-cs\xfaszka`
};


export {$da9b443e89eebc6b$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
